import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import WorkIcon from '@material-ui/icons/WorkOutline';

import THEME from '../../../../../constants/theme';

export const AddBagButton = styled(Button)`
  color: ${THEME.primary} !important;
  font-family: Montserrat !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.14 !important;
  letter-spacing: 1.5px !important;
`;

export const AddBagContainer = styled.div`
  align-items: flex-end;
  display: flex;
`;

export const AddBagIcon = styled(WorkIcon)`
  font-size: 18px !important;
  margin-right: 10px;
`;

export const BagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const Container = styled.div`
  border-bottom: 1px solid ${THEME.lightGrey};
  display: flex;
  flex-direction: column;
  padding: 20px 25px 20px 50px;
`;

export const DataContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Error = styled.span`
  color: ${THEME.error};
  font-size: 14px;
  font-weight: 500;
`;

export const IdImage = styled.img`
  border: 1px solid ${THEME.grey};
  border-radius: 8px;
  height: 64px;
  width: 64px;
`;

export const PassengerContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1.8;
  flex-wrap: wrap;
  gap: 18px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Span = styled.span`
  color: ${THEME.grey};
  margin-right: 10px;
`;

export const SpanTitle = styled.span`
  color: ${THEME.grey};
  font-size: 18px;
  font-weight: 500;
  line-height: 1.11;
  margin-bottom: 10px;
  margin-right: 10px;
`;

export const Text = styled.div`
  color: ${THEME.bobBlack};
  display: flex;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
`;

export const Title = styled.span`
  color: ${THEME.bobBlack};
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 10px 0;
`;

export const Warning = styled.span`
  color: ${THEME.warning};
  font-size: 14px;
  font-weight: 500;
`;
